// extracted by mini-css-extract-plugin
export default {"overlay":"Rx-z","bodyOpen":"Sx-z","content":"Tx-z","header":"Ux-z","close":"Vx-z","closeNoHeading":"Wx-z"};